exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timezoneBox[data-v-d161acf0]{position:relative;margin-top:4px;padding:4px 6px;font-size:10px;line-height:1.4;background-color:#e6e6e6;border-radius:3px}.as[data-v-d161acf0]{position:absolute;right:0;top:0;padding:2px 8px;color:#fff;border-radius:0 0 0 4px}.as.asUser[data-v-d161acf0]{background:#da5772}.as.asDoctor[data-v-d161acf0]{background:#417daf}", ""]);

// exports
